import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	whatsThisDialogTrigger: {
		id: 'issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-trigger',
		defaultMessage: 'What’s this?',
		description:
			"Button text that opens an inline dialog with information about request types. Positioned above the 'Request Type' selection",
	},
	whatsThisDialogBody: {
		id: 'issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body',
		defaultMessage:
			'Request types allow requests to show in the Help Center, gain additional features in the issue view, and access work categories. {learnMoreAboutRequestTypesLink}.',
		description:
			"Body text for an inline dialog with information about request types. 'learnMoreAboutRequestTypesLink' is a link contain text of key 'sersersersersere'",
	},
	learnMoreAboutRequestTypesLink: {
		id: 'issue-create.modal.create-form.type-picker.request-type-changeboarding.learn-more-about-request-types-link',
		defaultMessage: 'Learn more about request types',
		description:
			"Link text to external documentation about request types. No full stop - it is included as part of 'issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body'",
	},
	whatsThisDialogBodyIssueTermRefresh: {
		id: 'issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body-issue-term-refresh',
		defaultMessage:
			'Request types allow requests to show in the Help Center, gain additional features in the detailed view of the work item, and access work categories. {learnMoreAboutRequestTypesLink}.',
		description:
			"Body text for an inline dialog with information about request types. 'learnMoreAboutRequestTypesLink' is a link contain text of key 'sersersersersere'",
	},
});
